<section [ngClass]="customClass">
  <mat-slide-toggle
    (change)="onToggle()"
    [(ngModel)]="selected"
    [disabled]="disabled"
    [disabledInteractive]="disabled"
    class="example-margin" />
</section>
